import { Box } from "grommet";
import DenyStatusProgress from "../DenyProgress";
import { useQuery } from "@apollo/client";
import { GET_DENY_STATUS } from "../../queries/user_queries";
import { useEffect } from "react";
import { getDecimal } from "../../util/numberUtil";

type Props = {
  isWidget?: Boolean;
};
const DenyStatusProgressBars = ({ isWidget }: Props) => {
  // broadcasterName used to be sent from here, but the resolver never read
  // it - it's decided server-side now (see resolvers.ts's `broadcaster`).
  const { loading, error, data, startPolling, stopPolling } =
    useQuery(GET_DENY_STATUS);

  useEffect(() => {
    if (isWidget) {
      startPolling(2000);
    } else {
      startPolling(20000);
    }
    return stopPolling;
  }, []);
  let denyStatus;
  if (data) {
    denyStatus = data.getDenyStatus;
  } else {
    return <></>;
  }

  const { isDenied, deniedby, unDeniedby, numberOfDenies, numberOfUndenies } =
    denyStatus;
  const denyProgress = getDecimal(numberOfDenies); // get the decimal and used for the progress
  const undenyProgress = getDecimal(numberOfUndenies); // get the decimal and use for the progress
  const numberRemainingDeny = Math.round(10 - denyProgress * 10);
  const numberRemainingUndeny = Math.round(10 - undenyProgress * 10);
  return (
    <Box
      margin={"small"}
      round
      pad={"xsmall"}
      justify="center"
      height={isWidget ? "144px" : undefined}
      style={{ backgroundColor: "rgba(193, 76, 193, .7)" }}
    >
      <DenyStatusProgress
        color="#6FFFB0"
        amount={undenyProgress}
        title="Undeny Progess (tip 69)"
        requiredTokens={numberRemainingUndeny}
      />
      <DenyStatusProgress
        color="#FF4040"
        amount={denyProgress}
        title="Deny Progress (tip 66)"
        requiredTokens={numberRemainingDeny}
      />
    </Box>
  );
};

export default DenyStatusProgressBars;
